import { render, staticRenderFns } from "./Chi-siamo.vue?vue&type=template&id=47bf9566&scoped=true&"
import script from "./Chi-siamo.vue?vue&type=script&lang=js&"
export * from "./Chi-siamo.vue?vue&type=script&lang=js&"
import style1 from "./Chi-siamo.vue?vue&type=style&index=1&id=47bf9566&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47bf9566",
  null
  
)

export default component.exports